'use client';

import { APP_EVENTS, logHubxEvent } from '@/app/providers/analytics';
import { setUploadIntent } from '@/features/tool/slices/uploadSlice';
import { PDF_ONLY_FILE_TYPES } from '@/features/tool/utils/uploadConstraints';
import { useAppDispatch } from '@/hooks/redux';
import { NextUI } from '@/components/NextUI';

const PromoAction = ({ label }: { label: string }) => {
  const dispatch = useAppDispatch();

  const showSideFunction = () => {
    dispatch(
      setUploadIntent({
        targetPath: '/app/edit-pdf?tool=edit-pdf',
        fileTypes: PDF_ONLY_FILE_TYPES,
        multiple: false,
      })
    );
    logHubxEvent({ eventName: APP_EVENTS.BTN_HOME_GET_PREMIUM });
  };

  return (
    <div>
      <NextUI.Button onClick={() => showSideFunction()}>
        {label}
      </NextUI.Button>
    </div>
  );
};

export default PromoAction;
